import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { useAppContext } from '../context';

function PrivateRoute({ children, ...rest }) {
  const { isAuthenticated } = useAppContext();
  
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
